var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolumeOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.44336 10.2647V14.2647C2.44336 16.2647 3.44336 17.2647 5.44336 17.2647H6.87336C7.24336 17.2647 7.61336 17.3747 7.93336 17.5647L10.8534 19.3947C13.3734 20.9747 15.4434 19.8247 15.4434 16.8547V7.67468C15.4434 4.69468 13.3734 3.55468 10.8534 5.13468L7.93336 6.96468C7.61336 7.15468 7.24336 7.26468 6.87336 7.26468H5.44336C3.44336 7.26468 2.44336 8.26468 2.44336 10.2647Z",
    stroke: "#292D32",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4434 8.26465C20.2234 10.6346 20.2234 13.8946 18.4434 16.2646",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2734 5.76465C23.1634 9.61465 23.1634 14.9146 20.2734 18.7646",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeOn);
export default __webpack_public_path__ + "static/media/volume-on.6bdbe38b.svg";
export { ForwardRef as ReactComponent };